import { Divider, Link, Spacer, Typography } from "@fullscript/aviary-web";
import type { ReactNode } from "react";
import { Trans, useTranslation } from "react-i18next";

import { sharedRoutes } from "@shared/data/sharedRoutes";
import { l } from "@shared/locales/i18n";

import { ResendOtp } from "../../components/ResendOtp/ResendOtp";

import * as styles from "./EnableWithEmail.styles";

interface Props {
  emailMasked: string;
  children: ReactNode;
  isVerifyChangeFlow?: boolean;
  isModal?: boolean;
}

const EnableWithEmail = ({ emailMasked, children, isVerifyChangeFlow, isModal }: Props) => {
  const { t } = useTranslation();

  const renderTitle = () => {
    if (isVerifyChangeFlow) {
      return null;
    }

    if (isModal) {
      return (
        <>
          <Typography variant="h4" intention="neutral" colorIntensity="bold">
            {t(l.mfa.enableWithEmail.title)}
          </Typography>
          <Typography isMarginless>{t(l.mfa.enableWithEmail.subtitle)}</Typography>
          <Typography>
            <Link href={sharedRoutes.external.enablingMultiFactorAuthenticationEmailOption}>
              {t(l.sharedCommon.learnMore)}
            </Link>
          </Typography>
          <Spacer />
        </>
      );
    }

    return (
      <div css={styles.header}>
        <Typography variant="h1" intention="neutral" colorIntensity="bold">
          {t(l.mfa.enableWithEmail.title)}
        </Typography>
      </div>
    );
  };

  return (
    <>
      {renderTitle()}
      <Typography fontWeight="bold" isMarginless>
        {t(l.mfa.step1)}
      </Typography>
      <Typography>
        <Trans i18nKey={l.mfa.enableWithEmail.codeSentToEmail} values={{ emailMasked }} />
      </Typography>
      <ResendOtp email={emailMasked} isVerifyChangeFlow={isVerifyChangeFlow} />
      <Divider customCss={styles.separator} />
      <Typography fontWeight="bold" isMarginless>
        {t(l.mfa.step2)}
      </Typography>
      <Typography>{t(l.mfa.enableWithEmail.enterCodeFromEmail)}</Typography>
      {children}
      <Spacer />
    </>
  );
};

export { EnableWithEmail };
